import Loading from '../../../Common/Loading';
import { useResultsChartsDataContext } from './hooks/useResultsChartsDataContext';
import { Indicators } from './Indicators';
import { BirthTimeBars } from './BirthTimeBars';
import { BirthTimeDonut } from './BirthTimeDonut';
import { MonthlyLiveBirths } from './MonthlyLiveBirths';
import { AnnualLiveBirths } from './AnnualLiveBirths';

export const Charts = () => {
    const { isLoading } = useResultsChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <Indicators />
            <div className="charts-side-by-side-dashboards">
                <BirthTimeBars />
                <BirthTimeDonut />
            </div>
            <div className="charts-side-by-side-dashboards">
                <MonthlyLiveBirths />
                <AnnualLiveBirths />
            </div>
        </>
    );
};
